<template>
  <router-view />
</template>

<script>
export default {
  name: 'training-reports-page-container',
};
</script>
